/*
 * Warenkorb-Drawer (Paket D): Rückmeldung und Fokus nach Mengenänderungen.
 *
 * Ergänzt nur die vorhandene Cart-Logik aus theme.js und ändert deren Ablauf nicht.
 * Es werden keine Warenkorbdaten geschrieben oder gelesen. Genutzt werden ausschließlich die
 * bestehenden Ereignisse: line-item-quantity:change:start/end und cart:rerendered.
 *
 * 1. Scheitert eine Mengenänderung (z. B. mehr als verfügbar), sendet theme.js das Ereignis "change:end"
 *    ohne Warenkorb. Shopify kann die Menge dabei trotzdem auf den verfügbaren Bestand setzen (Antwort 422,
 *    Menge im Warenkorb geändert). Deshalb lädt der Drawer den Serverstand neu (cart:refresh ohne Daten, wie
 *    im Theme vorgesehen) und zeigt die Meldung danach an derselben Zeile (über den Line-Item-Key).
 * 2. Nach dem Neurendern des Drawers (innerHTML wird ersetzt) ging der Tastaturfokus verloren.
 *    Wir setzen ihn auf das gleiche Bedienelement derselben Zeile zurück.
 * 3. Eine unsichtbare Statusmeldung (aria-live) nennt die neue Artikelzahl und Zwischensumme.
 * 4. Monk (Geschenkaktion) wird im Drawer weder neu angestoßen noch gespiegelt. Monks Geschenkauswahl blieb im AJAX-Drawer
 *    leer (E2E belegt); unterstützt ist sie nur auf der vollen Warenkorbseite. Der Drawer führt berechtigte Warenkörbe
 *    deshalb über /cart zur Kasse (sections/mini-cart.liquid), die Vorteilsleiste kommt aus cart-drawer-monk-ui.js.
 * 5. Kassenbutton während eigener Warenkorbänderungen im Drawer sperren (Mengenänderung, Empfehlung hinzufügen), bis
 *    der Drawer neu aufgebaut ist. Davor zeigt das Formular den alten Stand; ein Kassenklick in diesem Fenster ging
 *    mit veralteten Mengen oder vor Monks Geschenkprüfung raus. Sicherung: Freigabe nach 8 s, falls kein Neuaufbau kommt.
 * 6. Bezahltes Monk-Geschenk (Liquid sperrt die Kasse, siehe sections/mini-cart.liquid): Bleibt die Zeile länger
 *    als 8 s (Monk entfernt sie nicht), wird der Hinweistext durch die Bitte ersetzt, sie selbst zu entfernen, und
 *    erst dann der Link "Geschenk jetzt entfernen" gezeigt. Er entfernt die Zeile per change.js über ihren Key und
 *    baut den Drawer neu auf.
 * 7. Empfehlungen "Auch interessant": Slider starten, sobald die Karten eingesetzt sind. Das Inline-Skript in
 *    snippets/cart_upsell_recommendations_products.liquid läuft nur, wenn der Warenkorb beim Seitenaufruf schon gefüllt
 *    war. Kommt der Drawer-Inhalt erst nach dem ersten Hinzufügen per innerHTML, führt der Browser das Skript nicht aus:
 *    kein Slider, jede Karte so breit wie der Bereich, nur die erste erreichbar (09.10. gemessen). Ein bereits
 *    gestarteter Slider (z. B. durch das Inline-Skript) bleibt unberührt.
 */
(function () {
  if (window.__ankerherzCartDrawer) {
    return;
  }
  window.__ankerherzCartDrawer = true;

  var ERROR_TEXT = "Die gewünschte Menge ist nicht verfügbar. Bitte prüfe die Menge.";
  var lastControl = null;
  var errorLineKey = null;
  var liveRegion = null;

  function closestLine(node) {
    return node && node.closest ? node.closest("line-item") : null;
  }

  function rememberControl(event) {
    var target = event.target;
    if (!target || !target.closest) {
      return;
    }
    var drawer = target.closest("#mini-cart");
    var line = closestLine(target);
    if (!drawer || !line) {
      lastControl = null;
      return;
    }
    var kind = null;
    if (target.closest("[data-cart-plus]")) {
      kind = "plus";
    } else if (target.closest("[data-cart-minus]")) {
      kind = "minus";
    } else if (target.closest(".cart-remove-button")) {
      kind = "remove";
    } else if (target.matches && target.matches('input[name="updates[]"]')) {
      kind = "input";
    }
    lastControl = kind ? { key: line.getAttribute("data-line-key"), kind: kind } : null;
  }

  document.addEventListener("click", rememberControl, true);
  document.addEventListener("change", rememberControl, true);

  document.addEventListener("line-item-quantity:change:start", function (event) {
    var line = closestLine(event.target);
    if (!line) {
      return;
    }
    line.classList.remove("line-item--error");
    var previous = line.querySelector(".line-item__error");
    if (previous) {
      previous.remove();
    }
  });

  function showError(line) {
    line.classList.add("line-item--error");
    var holder = line.querySelector("line-item-quantity");
    if (holder && !holder.querySelector(".line-item__error")) {
      var message = document.createElement("p");
      message.className = "line-item__error";
      message.setAttribute("role", "alert");
      message.textContent = ERROR_TEXT;
      holder.appendChild(message);
    }
  }

  document.addEventListener("line-item-quantity:change:end", function (event) {
    if (event.detail && event.detail.cart) {
      return;
    }
    var line = closestLine(event.target);
    if (!line) {
      return;
    }
    errorLineKey = line.getAttribute("data-line-key");
    document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }));
  });

  function announce(text) {
    if (!liveRegion) {
      liveRegion = document.createElement("div");
      liveRegion.className = "visually-hidden";
      liveRegion.setAttribute("role", "status");
      liveRegion.setAttribute("aria-live", "polite");
      document.body.appendChild(liveRegion);
    }
    liveRegion.textContent = "";
    window.setTimeout(function () {
      liveRegion.textContent = text;
    }, 50);
  }

  // 5. Kassenbutton während eigener Änderungen sperren
  var BUSY_FALLBACK_MS = 8000;
  var busyTimer = null;

  function checkoutButton() {
    var drawer = document.getElementById("mini-cart");
    return drawer ? drawer.querySelector('button[name="checkout"]') : null;
  }

  function releaseCheckout(button) {
    // Nur die hier gesetzte Sperre lösen; die Sperre aus Liquid (bezahltes Geschenk) bleibt bestehen
    if (!button || !button.isConnected || !button.hasAttribute("data-cart-busy")) {
      return;
    }
    button.removeAttribute("data-cart-busy");
    button.removeAttribute("aria-busy");
    button.disabled = false;
  }

  function lockCheckout() {
    var button = checkoutButton();
    if (!button || button.disabled) {
      return;
    }
    button.disabled = true;
    button.setAttribute("data-cart-busy", "");
    button.setAttribute("aria-busy", "true");
    window.clearTimeout(busyTimer);
    busyTimer = window.setTimeout(function () {
      releaseCheckout(button);
    }, BUSY_FALLBACK_MS);
  }

  document.addEventListener("line-item-quantity:change:start", function (event) {
    if (event.target && event.target.closest && event.target.closest("#mini-cart")) {
      lockCheckout();
    }
  });

  // Empfehlungen im Drawer legen über eigene Produktformulare in den Warenkorb
  document.addEventListener("submit", function (event) {
    var form = event.target;
    if (form && form.id !== "mini-cart-form" && form.closest && form.closest("#mini-cart")) {
      lockCheckout();
    }
  }, true);

  // Der Neuaufbau ersetzt den Button durch den frisch gerenderten (mit der Liquid-Sperre, falls nötig)
  document.addEventListener("cart:rerendered", function () {
    window.clearTimeout(busyTimer);
    releaseCheckout(checkoutButton());
  });

  // 6. Bezahltes Monk-Geschenk
  var PAID_GIFT_TIMEOUT_MS = 8000;
  var PAID_GIFT_STUCK_TEXT = "Das Geschenk konnte nicht automatisch entfernt werden. Bitte entferne es, bevor Du zur Kasse gehst.";
  var paidGift = { key: null, since: 0, timer: null };

  // Den Link erst zeigen, wenn Monk die Zeile nicht selbst entfernt hat: Entfernt der Kunde sie vorher, legt Monk das
  // Geschenk in derselben Sitzung nicht erneut an (Monks Zähler wird nur bei eigenem Entfernen zurückgesetzt).
  // Ohne JavaScript bleibt der Link sichtbar (dann entfernt auch Monk nichts).
  function applyPaidGiftState(key, stuck) {
    var note = document.querySelector('#mini-cart [data-paid-gift-key="' + key + '"]');
    if (!note) {
      return;
    }
    var text = note.querySelector("[data-paid-gift-text]");
    var link = note.querySelector("[data-paid-gift-remove]");
    if (stuck && text && text.textContent !== PAID_GIFT_STUCK_TEXT) {
      text.textContent = PAID_GIFT_STUCK_TEXT;
    }
    if (link) {
      link.hidden = !stuck;
    }
  }

  function checkPaidGift() {
    var note = document.querySelector("#mini-cart [data-paid-gift-key]");
    var key = note ? note.getAttribute("data-paid-gift-key") : null;
    window.clearTimeout(paidGift.timer);
    if (!key) {
      paidGift.key = null;
      return;
    }
    if (paidGift.key !== key) {
      paidGift.key = key;
      paidGift.since = Date.now();
    }
    var remaining = paidGift.since + PAID_GIFT_TIMEOUT_MS - Date.now();
    applyPaidGiftState(key, remaining <= 0);
    if (remaining > 0) {
      paidGift.timer = window.setTimeout(function () {
        applyPaidGiftState(key, true);
      }, remaining);
    }
  }

  document.addEventListener("cart:rerendered", checkPaidGift);
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", checkPaidGift);
  } else {
    checkPaidGift();
  }

  document.addEventListener("click", function (event) {
    var link = event.target.closest && event.target.closest("#mini-cart [data-paid-gift-remove]");
    if (!link) {
      return;
    }
    event.preventDefault();
    if (link.getAttribute("aria-disabled") === "true") {
      return;
    }
    link.setAttribute("aria-disabled", "true");
    fetch(window.themeVariables.routes.cartChangeUrl + ".js", {
      method: "POST",
      credentials: "same-origin",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: link.getAttribute("data-paid-gift-remove"), quantity: 0, sections: ["mini-cart"] }),
    })
      .then(function (response) {
        return response.ok ? response.json() : null;
      })
      .then(function (cart) {
        // Mit Daten sofort neu aufbauen, sonst (Zeile schon weg oder Fehler) den Serverstand neu laden.
        // cart:updated nur mit Daten: Zähler und andere Empfänger lesen detail.cart ohne Prüfung.
        if (cart) {
          document.documentElement.dispatchEvent(new CustomEvent("cart:updated", { bubbles: true, detail: { cart: cart } }));
          document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true, detail: { cart: cart } }));
        } else {
          document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }));
        }
      })
      .catch(function () {
        document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }));
      });
  });

  document.addEventListener("cart:rerendered", function () {
    var drawer = document.getElementById("mini-cart");
    if (!drawer) {
      return;
    }

    var count = drawer.querySelector(".cart-drawer__count");
    var total = drawer.querySelector(".total_price");
    if (count && total) {
      announce("Warenkorb aktualisiert. " + count.textContent.trim() + ", Zwischensumme " + total.textContent.trim() + ".");
    } else if (!count) {
      announce("Dein Warenkorb ist leer.");
    }

    if (errorLineKey) {
      var errorLine = drawer.querySelector('line-item[data-line-key="' + errorLineKey + '"]');
      if (errorLine) {
        showError(errorLine);
      }
      errorLineKey = null;
    }

    if (!lastControl || !drawer.hasAttribute("open")) {
      lastControl = null;
      return;
    }

    var line = drawer.querySelector('line-item[data-line-key="' + lastControl.key + '"]');
    var target = null;
    if (line) {
      // Sichtbares Mengenfeld, nicht das versteckte Mengenfeld einer Geschenkzeile (nicht fokussierbar)
      if (lastControl.kind === "plus") {
        target = line.querySelector("[data-cart-plus]") || line.querySelector(".quantity-selector__input");
      } else if (lastControl.kind === "minus") {
        target = line.querySelector("[data-cart-minus]");
      } else if (lastControl.kind === "input") {
        target = line.querySelector(".quantity-selector__input");
      }
    }
    if (!target) {
      // Zeile wurde entfernt oder ist nicht mehr da: Fokus auf den Schließen-Button statt auf die Seite dahinter.
      target = drawer.querySelector(".cart-drawer__close");
    }
    if (target && target.focus) {
      target.focus({ preventScroll: true });
    }
    lastControl = null;
  });

  // 7. Empfehlungs-Slider starten (siehe Kopf). Auch beim Laden dieser Datei einmal prüfen, falls die Empfehlungen schon
  //    eingesetzt waren, bevor der Listener stand.
  function startRecommendationSliders(root) {
    if (typeof window.Swiper !== "function" || !root || !root.querySelectorAll) {
      return;
    }
    var sliders = root.querySelectorAll("cart-drawer-recommendations .swiper[data-slider-options]");
    for (var i = 0; i < sliders.length; i++) {
      var slider = sliders[i];
      if ((slider.swiper && !slider.swiper.destroyed) || !slider.querySelector(".swiper-slide")) {
        continue;
      }
      try {
        new window.Swiper(slider, JSON.parse(slider.getAttribute("data-slider-options")));
      } catch (error) {
        // Ungültige Optionen: Die Karten bleiben ohne Slider wie bisher stehen.
      }
    }
  }

  document.addEventListener("recommendations:loaded", function (event) {
    startRecommendationSliders(event.target && event.target.querySelectorAll ? event.target : document);
  });
  startRecommendationSliders(document);
})();
